<div class="content-block">
  <article class="article " style="margin-top:1rem">


    <div class="back-container borderless">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
    </div>

    <div class="form-column borderless">
      <div style="width: 100%;">
        <label>Firstname</label>
        <input type="text" [(ngModel)]="firstname" />
      </div>

      <div style="width: 100%;">
        <label>Lastname</label>
        <input type="text" [(ngModel)]="lastname" />
      </div>

      <div style="width: 100%;">
        <label>Email</label>
        <input type="email" [(ngModel)]="email" />
      </div>

      <div style="width: 100%;">
        <label>Password</label>
        <input type="password" name="password1" [(ngModel)]="password" placeholder="unchanged" autocomplete="off" />
      </div>

      <div style="width: 100%;">
        <label>Confirm Password</label>
        <input type="password" name="password2" [(ngModel)]="password2" placeholder="unchanged" autocomplete="off" />
      </div>

      <div style="width: 100%;">
        <label>Multi-Factor Login (This will force this user to enter a One Time Passcode that is sent to their email address to login)</label>
        <input type="checkbox" id="switch-mfa" name="switch-mfa" role="switch"
          [(ngModel)]="mfa" />
      </div>

      <div style="width: 100%;">
        <label>User Type</label>
        <app-user-profile-picker [userId]="userId" (onProfileSet)="setUserProfile($event)"></app-user-profile-picker>
      </div>

    </div>

    <div class="form-column borderless buffer-bottom" *ngIf="userId == 3">
      <div style="width: 100%;">
        <label>Company</label>
        <app-company-picker [accountId]="companyId" [_placeholder]="'Please Select'"
          (onCompanySet)="setCompanyId($event)"></app-company-picker>
      </div>
      <!-- 
      <div  *ngIf="companyId != undefined">
        <label>Locations</label>
        <div class="add-on-control">
          <app-location-picker [locationId]="locationId" [companyId]="companyId" style="width:100%"
            (onLocationSet)="onLocationChange($event)">

          </app-location-picker>
          <button type="button" class="core-btn add-on" (click)="addLocation(locationId)"><i class="fa fa-plus"
              style="margin-right:0px" aria-hidden="true"></i></button>
          <button type="button" class="core-btn add-on" (click)="addAllLocations()">Add All</button>

        </div>
      </div> 

    <div class="col-md-6" *ngIf="companyId != undefined">
        <div  style="width: 100%;">
          <label>Assigned Locations</label>

          <table style="width:100%">
            <tr>
              <th style="padding:1%;width: 40%;border: 1px solid #ccc;">Location</th>

              <th style="padding:1%; width: 15%; border: 1px solid #ccc;">Remove</th>
            </tr>
            <ng-container *ngFor="let q of selectedLocations">
              <tr>
                <td style="padding:1%;width: 40%;border: 1px solid #ccc;">{{ q.name }} </td>
                <td style="padding:1%;width: 15%;border: 1px solid #ccc;">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <span class="remove-option" (click)="removeLocation(q.id)">
                      <i class="fa fa-trash" aria-hidden="true"></i>Remove
                    </span>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div> -->
    </div>



    <div class="btn-container">
      <button *ngIf="id != null && expired" class="btn btn-secondary" (click)="delete()">Reactivate</button>
      <button *ngIf="id != null && !expired" class="btn btn-secondary" (click)="delete()">Deactivate</button>

      <div class="spacer" *ngIf="id == null"></div>

      <button class="btn btn-primary" (click)="save()">Save</button>

    </div>


  </article>
</div>